<template>
  <div class="mt_140">

          <ccMenu ref="cc_menu" v-bind:posicao=1></ccMenu>
          <ccLoading v-show="loading" ref="cc_loading"></ccLoading>

          <div class="container">
          <div class="row">
          <div class="col-md-12">

            <!-- row -->
            <div class="row">

                <!-- coluna 2 -->
                <div class="col-md-2">
                  <ccMenuConta :num=5></ccMenuConta>
                </div>
                <!-- fim coluna 2 -->

                <!-- coluna 10 -->
                <div class="col-md-10 p-4" style="background: transparent linear-gradient(152deg, #FFFFFF0D 0%, #8080800D 100%) 0% 0% no-repeat padding-box; box-shadow: 0px 3px 6px #00000029;">

                  <div v-if="layout1">
                    <section class="mb-3 travado" v-bind:class="[{travado_div:travado==true}]">

                      <div class="text_laranja text-center mb-3" v-show="loading">
                        <div class="spinner-grow spinner-grow-sm" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        Carregando
                      </div>

                      <div class="row mb-3">
                        <div class="col-6 text_13 text_bold text_cinza"> SAQUE </div>
                      </div>

                      <div class="card">
                        <div class="card-body">

                          <div class="row mb-4">
                            <div class="col-6">
                              <label class="text_11 pb-2">Valor R$</label>
                              <input type="text" v-model="valor" class="form-control" placeholder="R$ 0,00">
                              <label class="text_12 text_cinza">Saque mínimo de R$ 1,00 </label>
                            </div>
                            <div class="col-6">
                              <div class="row mb-2">
                                <div class="col-md-4"> <button class="btn btn-sm w-100" v-bind:class="[btn_active1?'btn-success':'btn-secondary']" @click="habilitar_cpf()">CPF</button> </div>
                                <!-- <div class="col-md-4"> <button class="btn btn-sm w-100" v-bind:class="[btn_active2?'btn-success':'btn-secondary']" @click="habilitar_email()">E-MAIL</button> </div>
                                <div class="col-md-4"> <button class="btn btn-sm w-100" v-bind:class="[btn_active3?'btn-success':'btn-secondary']" @click="habilitar_telefone()">TELEFONE</button> </div> -->
                              </div>

                              <input type="text" v-show="show_cpf" v-model="cpf" class="form-control disabled text_bold text_12" placeholder="User Name" disabled>
                              <input type="text" v-show="show_email" v-model="email" class="form-control text_12" placeholder="Email">
                              <the-mask :mask="['(##)#####-####']" masked v-show="show_telefone" type="text" v-model="telefone" class="form-control" placeholder="Telefone" />
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <label class="text_12 text_cinza mb-2">Taxa de Saque 1.99%</label>
                              <button class="btn btn-outline-success btn-sm w-100 text_13 p-2 mb-1 text_bold" v-bind:class="[valor<1?'disabled':'']" @click="saque()">
                                VOCÊ RECEBERÁ: R$ {{ formatarMoeda(valor - ((valor*1.99)/100)) }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                    </section>
                  </div>

                  <div v-show="layout2">
                    <div class="row" v-show="layout2">
                      <div class="col-md-12">
                        <div class="col-md-12 text_branco mb-2 text_25 text_bold text-center"> Solicitação feita com sucesso. </div>
                        <div class="col-md-12 text_branco mb-2 text_bold text-center">
                          <RouterLink to="extrato/transacao">
                          Acompanhe a sua transação aqui.
                          </RouterLink>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-show="layout3">
                    <div class="row" v-show="layout3">
                      <div class="col-md-12">
                        <div class="col-md-12 text_branco mb-2 text_25 text_bold text-center"> Saque desabilitado! </div>
                        <div class="col-md-12 text_branco mb-2 text-center mb-5"> Sua conta ainda não foi verificada </div>
                        <div class="col-md-12 text_branco mb-2 text_bold text-center">
                          <RouterLink to="conta/verificada">
                            Verifique aqui os passos para verificação.
                          </RouterLink>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              <!-- fim coluna 10 -->

            </div>
            <!-- fim row -->

        </div>
        </div>
        </div>

        <ccMensagem ref="cc_mensagem"></ccMensagem>
        <ccFooter></ccFooter>



        <!-- Modal Extraordinário-->
        <div class="modal fade" id="staticBackdropExtraordinario" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">

            <div class="modal-content modal-content-azul">
              <div class="modal-body">
                <div class="text_18 mb-3 text_azul"> <b>{{titulo}}</b> </div>
                <div class="mb-4 text_cinza"> <b>Saque bloqueado! Valor de apostas 10% menor ao valor depositado</b> </div>
                <div class="row">
                  <div class="col-md-6">
                    <a href="https://sokkerduel.com/como-funciona/politica-anti-lavagem-dinheiro/"
                    class="btn btn-sm btn-success w-100 text_bold" target="_blank">
                      Saiba mais
                    </a>
                  </div>
                  <div class="col-md-6">
                    <button type="button" class="btn btn-sm btn-info w-100 text_bold" data-bs-dismiss="modal">
                      Entendi
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

  </div>
</template>


<script>

  import axios from 'axios';
  import {TheMask} from 'vue-the-mask';
  import ccMenu from '../layout/menu.vue'
  import ccMenuConta from '../conta/menu_conta.vue'
  import ccLoading from '../cc_geral/cc_loading.vue'
  import { RouterLink } from 'vue-router';
  import ccFooter from '../layout/footer.vue'
  import ccMensagem from '../cc_geral/mensagem.vue'

  export default {
    data () {
      return {
        titulo: 'SAQUE',

        //geral
        base_url_api: process.env.BASE_URL_API,
        user: {},
        loading: false,
        errors: [],
        disponivel: 0,
        nome_completo: null,
        cpf: null,
        email: null,
        telefone: null,
        valor: null,
        travado: false,
        conta_check_verificada: 0,
        layout1: false,
        layout2: false,
        layout3: false,
        show_cpf: true,
        show_email: false,
        show_telefone: false,
        btn_active1: false,
        btn_active2: false,
        btn_active3: false,
      }
    },

    components: { ccMenu, TheMask, ccMenuConta, ccLoading, RouterLink, ccFooter, ccMensagem},

    created()
    {
      document.title = 'Minha Conta: Saque - SokkerDuel';

      localStorage.setItem("base_url_api_mobile", this.base_url_api)

      let a = JSON.parse(localStorage.getItem("user"));
      if (a == null){ this.user = {} }else{ this.user = a }

      this.get_user_completo()
    },

    methods: {

      get_user_completo(){
        this.loading = true;
        var header = {'headers': {'x-access-token': this.user.access_token, }};
        axios.get(this.base_url_api+'user/completo', header)
        .then(response => {
          this.nome_completo = response.data.resp.nome_completo
          this.cpf = response.data.resp.cpf
          this.conta_check_verificada = response.data.resp.conta_check_verificada

          var balance_total = parseFloat(response.data.resp.balance) + parseFloat(response.data.resp.balance_convidado)
          this.disponivel = this.formatarMoeda(balance_total - (balance_total * 2)/100)

          this.loading = false

          if( ([0,2].includes(this.conta_check_verificada)) ){
            this.layout3 = true
          }else{
            this.layout1 = true
            this.layout2 = false
            this.layout3 = false
          }
        })
        .catch(e => {
          this.errors.push(e);
          this.expluse_para_login()
        });
      },

      saque() {

        this.loading = true
        let v = this.valor.replace(/,/g, '.')

        let taxIdAux = this.cpf
        if(this.show_cpf == true){ taxIdAux = this.cpf }
        if(this.show_email == true){ taxIdAux = this.email }
        if(this.show_telefone == true){ taxIdAux = this.telefone }

        var body = {
          dictKey: taxIdAux,
          name: this.nome_completo,
          taxId: this.cpf,
          amount: v,
          expiration: 3600,
          tags: [
            'sokkerDeskSetSaque'
          ],
        }

        var header = {'headers': {'x-access-token': this.user.access_token, }};
        axios.post(this.base_url_api+'set/saque', body, header)
        .then(response => {

            if (response.status == 200) {
              this.cod_externo = response.data.id
              this.name = response.data.name

              this.layout1 = false
              this.layout2 = true
              this.layout3 = false
              this.loading = false

              //atualize balance no menu
              this.atualize_menu()
            }
        })
        .catch(e => {
          this.loading = false
          let texto = "";

          if(e.response.data[0].status == 'saque_bloqueado_valor_de_apostas_10%_menor_ao_ultimo_deposito'){
              var myModal = new bootstrap.Modal(document.getElementById('staticBackdropExtraordinario'))
              myModal.show()
              return;
          }

          switch(e.response.data[0].status){
            case 'nao_possui_balance_suficiente':
              texto = 'Não possui dinheiro suficiente!'
              break;
            case 'saque_bloqueado_valor_de_apostas_10%_menor_ao_ultimo_deposito':
              texto = 'Para sacar, é necessário fazer um depósito e jogar pelo menos 10% desse valor.';
              break;
            case 'saque_bloqueado_excedeu_max_dia':
              texto = 'Saque bloqueado! Excedeu o valor máximo de saques por dia.'
              break;
          }

          var obj = {
                cor: 1,
                titulo: texto,
                texto: '',
                btn1_ativo: false,
                btn1_cor: 1,
                btn1_texto: 'ACESSAR',
                btn1_link: '/login',
                btn1_link_next: true,
                btn2_ativo: true,
                btn2_cor: 3,
                btn2_texto: 'Entendi',
                btn2_link: '#',
                btn2_link_next: false,
          }
          this.$refs.cc_mensagem.receber_dados(obj);
        });

      },

      habilitar_cpf(){
        this.show_cpf = true
        this.show_email = false
        this.show_telefone = false

        this.btn_active1 = true
        this.btn_active2 = false
        this.btn_active3 = false
      },

      habilitar_email(){
        this.show_cpf = false
        this.show_email = true
        this.show_telefone = false

        this.btn_active1 = false
        this.btn_active2 = true
        this.btn_active3 = false
      },

      habilitar_telefone(){
        this.show_cpf = false
        this.show_email = false
        this.show_telefone = true

        this.btn_active1 = false
        this.btn_active2 = false
        this.btn_active3 = true
      },

    }

  }

  </script>

  <style scoped>
    .card{
      background: #FFFFFF08 0% 0% no-repeat padding-box;
      color:#fff;
    }

    input.form-control {
      background: transparent linear-gradient(180deg, #FFFFFF0D 0%, #8080800D 100%) 0% 0% no-repeat padding-box;
      color: #909196;
      margin-bottom: 10px;
      border: none;
      padding: 10px;
      font-size: 13px;
    }

    input.form-control.disabled {
      background-color: #21232d;
      background-image: url("../../assets/image/cadeado.svg");
      background-size: 20px;
      background-position: right;
      background-repeat: no-repeat;
    }

    select.form-control {
      background: transparent linear-gradient(180deg, #FFFFFF0D 0%, #8080800D 100%) 0% 0% no-repeat padding-box;
      color: #909196;
      margin-bottom: 10px;
      border: none;
      padding: 10px;
      font-size: 13px;
    }

    input.form-control::placeholder {
      color: #B7B7B780;
      font-size: 13px;
    }

    option[value=0] {
      color: red;
    }

    .travado_div{
      pointer-events: none;
      opacity: 0.5;
    }

    textarea{
      color: red;
      background-color: transparent;
      border: none;
    }


    .modal-content{
      background: transparent linear-gradient(68deg, #071A24 0%, #000000 100%) 0% 0% no-repeat padding-box;
    }
    .modal-content-verde{
      border-left: solid 10px #5ABB10;
    }
    .modal-content-vermelho{
      border-left: solid 10px red;
    }
    .modal-content-azul{
      border-left: solid 10px blue;
    }
  </style>



// WEBPACK FOOTER //
// src/components/conta/saque.vue